import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import HlushmanHouseCard from "../../v1/HlushmanHouseCard";
import SellHouse from "../../v2/pages/SellHouse";
import NotFoundPage from "../views/default/404";
import Layout from "../views/template/layout";
import AboutUsPage from "../views/default/about";
import ContactsPage from "../views/default/contacts";
import SitemapPage from "../views/default/site-map";
import LegalPage from "../views/default/legal";
import HomePage from "../../v2/pages/HomePage";
import RentHouse from "../../v2/pages/RentHouse";

export const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        errorElement: <NotFoundPage />,
        children: [
            { index: true, element: <HomePage /> },
            { path: '/about', element: <AboutUsPage /> },
            { path: '/contacts', element: <ContactsPage /> },
            { path: '/legal/:document', element: <LegalPage /> },
            { path: '/sitemap', element: <SitemapPage />, },
            { path: '*', element: <NotFoundPage />, },
        ],
    },

    { path: '/links', element: <HlushmanHouseCard /> },

    { path: '/sell-house', element: <SellHouse /> },
    { path: '/rent-house', element: <RentHouse /> },
]);